/**
 * @generated SignedSource<<e90a5666acdcbe1bc3e3d72886375527>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DependentEditQuery$variables = {
  id: string;
};
export type DependentEditQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DependentEdit_query">;
};
export type DependentEditQuery = {
  response: DependentEditQuery$data;
  variables: DependentEditQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DependentEditQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "DependentEdit_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DependentEditQuery",
    "selections": [
      {
        "alias": "dependent",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "relationship",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "birthday",
                "storageKey": null
              }
            ],
            "type": "CandidateDependent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelValue",
        "kind": "LinkedField",
        "name": "availableDependentRelationships",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "label",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CompanyRequiredDocsDependentKind",
            "kind": "LinkedField",
            "name": "requiredDocsDependents",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dependentKind",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CompanyRequiredDocs",
                "kind": "LinkedField",
                "name": "requiredDocs",
                "plural": true,
                "selections": [
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "878bf36af8e27797e4ce377540c5a377",
    "id": null,
    "metadata": {},
    "name": "DependentEditQuery",
    "operationKind": "query",
    "text": "query DependentEditQuery(\n  $id: ID!\n) {\n  ...DependentEdit_query_1Bmzm5\n}\n\nfragment DependentEdit_query_1Bmzm5 on Query {\n  dependent: node(id: $id) {\n    __typename\n    id\n    ... on CandidateDependent {\n      relationship\n      ...DependentFormCard_dependent\n    }\n  }\n  ...DependentFormCard_query\n}\n\nfragment DependentFormCard_dependent on CandidateDependent {\n  id\n  name\n  birthday\n  relationship\n}\n\nfragment DependentFormCard_query on Query {\n  availableDependentRelationships {\n    label\n    value\n  }\n  companyDomainName {\n    requiredDocsDependents {\n      dependentKind\n      requiredDocs {\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0a306e1d3a8bbf4064f5340973b90b6c";

export default node;
